module.exports = __webpack_public_path__ + "img/Bundle.6bc9659f.gif";